import { Pipe, PipeTransform } from '@angular/core';
import { ProjectChecklist } from '@portal-core/project-checklists/models/project-checklist.model';
import { ProjectChecklistsService } from '@portal-core/project-checklists/services/project-checklists/project-checklists.service';
import { Observable, of } from 'rxjs';

@Pipe({
  name: 'mcProjectChecklistAsync'
})
export class ProjectChecklistAsyncPipe implements PipeTransform {
  constructor(private projectChecklistsService: ProjectChecklistsService) { }

  transform(checklistId: number | null | undefined, allowApiRequest: boolean = false): Observable<ProjectChecklist | null> {
    if (!checklistId) {
      return of(null);
    }

    return this.projectChecklistsService.getItemById$(checklistId, {
      allowApiRequest
    });
  }
}
